module.exports = __webpack_public_path__ + "img/Liaoning-speed.cf490924.png";